var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorPicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.76 46.16a2 2 0 010 2.83L35 78.71a2 2 0 01-.69.45l-17.82 6.9a2 2 0 01-2.59-2.59l6.9-17.82a2 2 0 01.45-.69L51 35.24a2 2 0 012.83 2.83L24.42 67.49 19.3 80.7l13.2-5.11 29.43-29.43a2 2 0 012.83 0zM83.35 30.4l-9.4 9.4 4.94 4.94a2 2 0 11-2.83 2.83l-6.35-6.35-10.92-10.93-6.35-6.35a2 2 0 012.83-2.83l4.94 4.94 9.4-9.4a9.72 9.72 0 0113.75 0 9.72 9.72 0 010 13.75zm-1.15-6.88a5.72 5.72 0 00-9.77-4L63 28.88 71.12 37l9.4-9.4a5.69 5.69 0 001.68-4.08z",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.01
  })));
}
export default SvgColorPicker;